'use strict';
const angular = require('angular');

module.exports = angular
  .module('app.components.popovers', [])
  .factory('$popover', require('./PopoverService.js'))
;



// WEBPACK FOOTER //
// ./src/js/core-components/popovers/index.js